import React from 'react';

import MIcon from 'views/MIcon/MIcon';

import classes from './MFormHeader.module.scss';
import { VscClose } from 'react-icons/vsc';
import { TbArrowsDiagonal2, TbArrowsDiagonalMinimize } from 'react-icons/tb';

type Props = {
  className?: string;
  title?: string;
  headerActions?: JSX.Element | JSX.Element[] | null;
  isFullScreen?: boolean;
  onBack?: () => void;
  onFullScreen?: () => void;
};

const MFormHeaderView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className={`${classes['container']} ${props.className || ''}`.trim()}>
      {props.onBack ? (
        <button className={classes['btnClose']} onClick={props.onBack}>
          <MIcon name={VscClose}></MIcon>
        </button>
      ) : null}
      <span className={classes['title']}>{props.title}</span>
      {props.headerActions}
      {props.onFullScreen ? (
        <button className={classes['btnFullScreen']} onClick={props.onFullScreen}>
          {props.isFullScreen ? <MIcon name={TbArrowsDiagonalMinimize}></MIcon> : <MIcon name={TbArrowsDiagonal2}></MIcon>}
        </button>
      ) : null}
    </div>
  );
};

MFormHeaderView.displayName = 'MFormHeaderView';
MFormHeaderView.defaultProps = {};

export default MFormHeaderView;
